import { toRem, theme } from '@marriott/mi-ui-library-shop';
import rtl from 'styled-components-rtl';
import styled from 'styled-components';

export const StyledMapToolTip = styled.div`
  ${rtl`

  .custom-position{
    top:15%;
    margin: 0 auto;
  }
  .popup-close-button{
    background-color:${theme.color['gallery']};
    font-size:large;
  }

.tooltip-popup-wrapper{
    max-height:${toRem(513)};
    min-height:${toRem(290)};
  }
  .custom-heights{
    height:auto !important;
    max-height:${toRem(400)} !important;
    overflow-y:auto !important;
    @media only ${theme.mediaQuery.minDesktop}, ${theme.mediaQuery.desktop}, ${theme.mediaQuery.largeDesktop} {
      padding-top: ${toRem(32)} !important;
    }
    @media only ${theme.mediaQuery.allMobiles}, ${theme.mediaQuery.allTablets} {
      padding-top: ${toRem(23.5)} !important;
    }
  }
  .tooltip-main-wrapper{
    height:${toRem(200)};
    font-size:${toRem(16)};
    font-family: ${theme.fonts['fontFamilySwiss']};
    letter-spacing: 0;
    line-height: ${toRem(20)};
    color:${theme.color['dark-gray-14']};
    font-weight: ${theme.fonts['fontWeightMedium']};
  }
  .tooltip-main-content{
    // margin:${toRem(15)} 0 0 0;
    font-size:${toRem(12)};
    letter-spacing: 0;
    font-family:${theme.fonts['fontFamilySwiss']};
    line-height: ${toRem(18)};
    font-weight: ${theme.fonts['fontWeightRegular']};
    padding-top: ${toRem(16)};
    @media only ${theme.mediaQuery.allTablets} {
      padding-top: ${toRem(12)} ;
    }

  }
  .custom-list{
    //padding-left:${toRem(10)};
    width:100%;
    font-family:${theme.fonts['fontFamilySwiss']};
    font-weight: ${theme.fonts['fontWeightRegular']};
    padding-right: ${toRem(30)};
  }
  .custom-ul-props{
    column-count:2;
    margin-inline-start: ${toRem(-10)} !important;
    margin-inline-end: ${toRem(-30)} !important;
  }
  .row-reverse{
    flex-direction:row-reverse !important;
    background: ${theme.color['alabaster']};
    height:${toRem(81)};
  }
  .custom-header-font h4{
    font-size: ${toRem(22)};
    font-weight: ${theme.fonts['fontWeightMedium']};
    letter-spacing: 0;
    line-height: ${toRem(26)};
  }
  .custom-header-font{
    padding-top: ${toRem(32)};
    padding-bottom:${toRem(32)};
  }
  @media only ${theme.mediaQuery.smallerTablet} {

        .tooltip-popup-wrapper {
          max-height: ${toRem(640)};
          min-height: ${toRem(293)};
        }
        .custom-ul-props{
          column-count:1;
        }
        .popup-width {
          width: ${toRem(584)};
        }
        .custom-list {
          padding-left: ${toRem(10)};
          width: 100%;
          font-family: ${theme.fonts['fontFamilySwiss']};
          font-weight: ${theme.fonts['fontWeightRegular']};
        }
        .custom-header-font h4{
          font-size: ${toRem(22)};
          font-weight: ${theme.fonts['fontWeightMedium']};
          letter-spacing: 0;
          line-height: ${toRem(26)};
        }
        .popup-close-button{
          background-color:${theme.color['gallery']};
          font-size:x-large;
          height: ${toRem(32)};
          width: ${toRem(32)};

        }
    }
    @media only ${theme.mediaQuery.allMobiles} {
      .tooltip-popup-wrapper{
        max-height:${toRem(760)};
        min-height:${toRem(310)};
        margin-top:0;
      }
      .custom-ul-props{
        column-count:1;
      }
      .popup-close-button{
          background-color:${theme.color['gallery']};
          font-size:large;
        }
      .row-reverse{
        height:${toRem(74)};
        background: ${theme.color['alabaster']};
      }
      .custom-list{
          padding-left:${toRem(10)};
          width:100%;
          font-family: ${theme.fonts['fontFamilySwiss']};
          font-weight: ${theme.fonts['fontWeightRegular']};
      }
      .custom-position{
        top:unset;
        margin: 0 auto;
      }
      .custom-header-font h4{
        font-size: ${toRem(18)};
        font-weight: ${theme.fonts['fontWeightMedium']};
        letter-spacing: 0;
        line-height: ${toRem(20)};
      }
      .custom-header-font{
        height: ${toRem(92.5)};
      }
      .popup-width {
          width: inherit;
        }
    }


  `}
`;
